<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Videos
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>Videos</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- =============latest videos========== -->
    <section>
        <div class="latest-blog cpy-8">
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-7 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h4>Videos Updates</h4>
                                <h2>Our Latest Videos</h2>
                                <p>
                                    Explore our latest videos featuring fresh content, insights, and updates. Watch now
                                    and stay informed!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--row end  -->

                <div class="video-tabing mt-5">
                    <ul class="nav nav-tabs justify-content-center" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation" *ngFor="let video of videoListArr; let v = index;">
                            <button class="nav-link" [ngClass]="{'active': currentTab == video?.id}" id="home-tab"
                                data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab"
                                aria-controls="home" aria-selected="true"
                                (click)="currentActiveCate(video?.id, v)">{{video?.category}}</button>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="tab-content mt-5" id="myTabContent">
                        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <div class="row justify-content-start">
                                <div class="col-lg-4 col-md-4 col-sm-6 mb-4"
                                    *ngFor="let vid of currentIndDetail; let vind = index;">
                                    <div class="post-card video-play-card position-relative">
                                        <div class="post-img">
                                            <img [src]="vid?.thumbnail" alt="{{vid?.title}}">
                                            <div class="video-play">
                                                <a (click)="videoOverlay.openVideo(vid?.video)" class="cursor-pointer play-video video-btn">
                                                    <span class="icofont-ui-play play-icon-larg"></span>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="post-details video-text">
                                            <a (click)="videoOverlay.openVideo(vid?.video)" class="cursor-pointer post-link">
                                                {{vid?.title}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            <p>This is the Profile tab content.</p>
                        </div> -->
                    </div>

                    <app-video-overlay #videoOverlay></app-video-overlay>

                    <!-- row end  -->
                </div>
                <!-- mt-5 end  -->
            </div>
        </div>
    </section>
    <!-- ========= Updates====latest videos end ========== -->